// Formats an ISO date string (YYYY-MM-DD) as DD/MM/YYYY without going through
// the Date object, so the displayed day never shifts due to timezone offsets.
export const formatDataPullDate = (
  isoDate: string | null | undefined,
): string | null => {
  if (!isoDate) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate);
  if (!match) return null;
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
};
